import React, { useState } from 'react';
import { Link } from 'gatsby';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import ScrollDown from 'components/ScrollDown';

import { indexHero } from 'utils/contentProvider';

import { Section } from './SectionHomeHero.styled';

const SectionHomeHero = () => {
  const [currentHeroTab, setCurrentHeroTab] = useState(0);

  function heroTabChangeHandler(e) {
    setCurrentHeroTab(Number(e.target.dataset.id));
  }

  return (
    <Section>
      <div className="container">
        <div>
          <ScrollDown style={{ top: '40%' }} />
          <TransitionGroup>
            <CSSTransition
              key={currentHeroTab}
              timeout={1700}
              classNames="hero-transition"
            >
              <div className="row align-items-center">
                <div className="col-md-5 hero-content">
                  <h1 className={`white title-${currentHeroTab}`}>
                    {indexHero[currentHeroTab].title}
                    <span className="pink">.</span>
                  </h1>
                  <div className="hero-content-border">
                    <h2 className="white">
                      {indexHero[currentHeroTab].subtitle}
                    </h2>
                    <Link
                      to="/contact-us/"
                      className="button center d-inline-block"
                    >
                      Get In Touch
                    </Link>
                  </div>
                </div>
                <div className="col-md-7">
                  <img
                    src={indexHero[currentHeroTab].image}
                    alt={indexHero[currentHeroTab].title}
                    className="hero-image"
                  />
                </div>
              </div>
            </CSSTransition>
          </TransitionGroup>
        </div>
        <ul className="navigation d-none d-md-flex justify-content-between">
          <li className={currentHeroTab === 0 ? 'active' : ''}>
            <button type="button" data-id={0} onClick={heroTabChangeHandler}>
              01 &nbsp;
              {indexHero[0].title}
            </button>
          </li>
          <li className={currentHeroTab === 1 ? 'active' : ''}>
            <button type="button" data-id={1} onClick={heroTabChangeHandler}>
              02 &nbsp;
              {indexHero[1].title}
            </button>
          </li>
          <li className={currentHeroTab === 2 ? 'active' : ''}>
            <button type="button" data-id={2} onClick={heroTabChangeHandler}>
              03 &nbsp;
              {indexHero[2].title}
            </button>
          </li>
        </ul>
      </div>
    </Section>
  );
};

export default SectionHomeHero;
